import { CheckboxGroup, Divider, FormCheckbox } from 'omakase';
import { SearchFiltersFieldNames } from 'components/www/availability-search/SearchHeader';
import { consumer } from '@tock/coretypes';
import {
  dividers,
  fieldset,
} from 'components/www/availability-search/filters/searchFiltersCssDefs';
import { useCuisineAggregations } from 'hooks/search/useCuisineAggregations';
import React from 'react';

interface SearchFilterCuisinesProps {
  selectedCuisines: string[];
  aggregations?: consumer.Aggregations;
  aggregationsInternal?: consumer.Aggregations;
  setAggregationsInternal: (aggs?: consumer.Aggregations) => void;
}

const SearchFiltersCuisines: React.FunctionComponent<SearchFilterCuisinesProps> = ({
  aggregations,
  selectedCuisines,
  aggregationsInternal,
  setAggregationsInternal,
}) => {
  const { cuisines } = useCuisineAggregations(
    selectedCuisines,
    aggregations,
    aggregationsInternal,
    setAggregationsInternal
  );

  if (cuisines.length < 1) {
    return null;
  }

  return (
    <>
      <Divider css={dividers} position="middle" tall />
      <CheckboxGroup css={fieldset} disclosureMode="static" label="Cuisines">
        {cuisines.map((cuisineOption) => (
          <FormCheckbox
            key={`${cuisineOption}`}
            id={cuisineOption}
            label={cuisineOption}
            value={cuisineOption}
            weight="book"
            name={SearchFiltersFieldNames.cuisines}
            size="large"
          />
        ))}
      </CheckboxGroup>
    </>
  );
};

export default SearchFiltersCuisines;
